import * as React from 'react';

// Хук для сохранения предыдущего значения переменной
export function usePrevious<T>(value: T) {
  const ref = React.useRef<T>(null);

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
